import IconBase from "./IconBase";

// Braces: the field holds a JSON object.
const ObjectIcon = (props) => (
    <IconBase {...props}>
        <path d="M9.5 3.5c-2 0-2 2-2 4s-1 4-3 4c2 0 3 2 3 4.5s0 4.5 2 4.5" />
        <path d="M14.5 3.5c2 0 2 2 2 4s1 4 3 4c-2 0-3 2-3 4.5s0 4.5-2 4.5" />
    </IconBase>
);

export default ObjectIcon;
